import $ from "jquery";
import manageRefineMenu from "../entry-points/plp/manage-refine-menu";

export const initSidePanel = () => {
    if (window.rcProps.sidebarHref) {
        const hrefEncoded = encodeURIComponent(window.location.href);
        $('.js-side-panel-sort-filter').sidePanel({
            url: `${window.rcProps.sidebarHref}?url=${hrefEncoded}`,
            onAjaxLoad: () => {
                $('.js-accordion-side-panel').accordion({
                    onLoad: () => {
                        $('.side-panel__panel').animate({
                            scrollTop: 0
                        }, 200);
                    }
                });
                manageRefineMenu();
                $('.js-product-filter-clear-all').productFilterClearAll();
                $('.js-product-filter-search').productFilterSearch();
                $('.js-product-filter-active-button').productFilterActiveButton();
                $('.js-product-filter-count').productFilterCount();

                $('#side-panel__overlay, #done_filters').on('click', function () {
                    if ($('.js-product-filter-clear-all').length) {
                        $('.js-accordion-side-panel').accordion('closeAll');
                    }
                });

            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/scripts/modules/init-side-panel.js